/// <amd-module name="SuiteCommerce.ProductComparison.RecordSearcher.EventsCatalog"/>
define("SuiteCommerce.ProductComparison.RecordSearcher.EventsCatalog", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var EventsCatalog;
    (function (EventsCatalog) {
        EventsCatalog["EXECUTE_SEARCH"] = "RecordSearcher.executeSearch";
        EventsCatalog["OPEN_SUGGESTIONS"] = "RecordSearcher.openSuggestions";
        EventsCatalog["SUGGESTION_CLICKED"] = "RecordSearcher.SuggestionClicked";
    })(EventsCatalog = exports.EventsCatalog || (exports.EventsCatalog = {}));
});
